import request from '@/utils/windyrequest';
import {errorFn, successFn} from '@/utils/windyrequestelementui';

export function snowflakeIdsFn() {
    return request({
        headers: {
            'X-Anti-Shake': true,
        },
        url: '/api/snowflake/ids',
        method: 'get',
        params: null,
        data: null,
        doNotSuccessNotification: false,
        successNotificationFn: successFn,
        errorNotificationFn: errorFn,
    })
} 